import { css } from 'emotion';

import { colors, icons } from '@cobliteam/base-components/src/styles';

export const rightSideWrapper = css`
  margin-left: auto;
  display: flex;
  align-items: center;
`;

export const ctaButtonWrapper = css`
  margin: 0 10px;

  > button > span {
    color: ${colors.white};
    text-decoration: underline;
  }
`;

export const alertCloseButtonClass = (hoverColor: string) => css`
  position: relative;
  cursor: pointer;
  border-radius: 30px;
  width: 36px;
  height: 36px;

  :hover {
    background: ${hoverColor};
  }

  svg {
    color: ${colors.white};
    width: ${icons.size.small};
  }
`;
